import { render } from "./Navbar.vue?vue&type=template&id=5fc9b7b1"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=5fc9b7b1&lang=css"

import exportComponent from "/var/www/corfits.id/e-budgeting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__